import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { storeGet, STORE_KEY_ACCOUNT } from 'mailup-react-helpers'

import { Flex, RadioButtonsGroup } from 'mailup-web-components'
import InputCustomUrl from './InputCustomUrl'
import InputFromLanding from './InputFromLanding'

import {
  inputState,
  INPUT_VALUE_CUSTOM_URL,
  INPUT_VALUE_LANDING_PAGE
} from '../../recoil/state/input'

const Input = () => {
  const intl = useIntl()

  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const [{ radioValue }, setInput] = useRecoilState(inputState, [])

  useEffect(() => {
    setInput(prev => ({
      ...prev,
      radioValue: IsTrial ? INPUT_VALUE_LANDING_PAGE : INPUT_VALUE_CUSTOM_URL
    }))
  }, [IsTrial])

  const items = [
    ...(IsTrial
      ? [
          {
            value: INPUT_VALUE_LANDING_PAGE,
            label: intl.formatMessage({
              id: 'Load.LinkUrlSelection.SelectLandingPageUrl'
            }),
            dataAttributeTest: 'radio-button__landing-page-url',
            'data-mu-test': 'radio-button__landing-page-url'
          },
          {
            value: INPUT_VALUE_CUSTOM_URL,
            label: intl.formatMessage({
              id: 'Load.LinkUrlSelection.CustomLinkDescription'
            }),
            dataAttributeTest: 'radio-button__custom-url',
            'data-mu-test': 'radio-button__custom-url'
          }
        ]
      : [
          {
            value: INPUT_VALUE_CUSTOM_URL,
            label: intl.formatMessage({
              id: 'Load.LinkUrlSelection.CustomLinkDescription'
            }),
            dataAttributeTest: 'radio-button__custom-url',
            'data-mu-test': 'radio-button__custom-url'
          },
          {
            value: INPUT_VALUE_LANDING_PAGE,
            label: intl.formatMessage({
              id: 'Load.LinkUrlSelection.SelectLandingPageUrl'
            }),
            dataAttributeTest: 'radio-button__landing-page-url',
            'data-mu-test': 'radio-button__landing-page-url'
          }
        ])
  ]

  const handleChange = e => {
    setInput(prev => ({ ...prev, radioValue: e, isDirty: true }))
  }

  return (
    <Flex flexDirection='column' rowGap='16px'>
      <RadioButtonsGroup
        value={radioValue}
        items={items}
        onChange={handleChange}
      />
      {radioValue === INPUT_VALUE_CUSTOM_URL && <InputCustomUrl />}
      {radioValue === INPUT_VALUE_LANDING_PAGE && <InputFromLanding />}
    </Flex>
  )
}

export default Input
